/** What changes while a page is offline. One row per true consequence. */
export enum UnpublishFactKind {
  /** The address stops answering, like any draft's does. */
  offline = 'offline',
  /** And it is no longer held for this page — a draft reserves nothing. */
  address = 'address',
  /** The campaign runs on regardless: delivery never reads the page. */
  presaves = 'presaves',
  /** Nothing recorded is deleted; only new traffic stops arriving. */
  analytics = 'analytics',
}

export interface UnpublishFactRow {
  kind: UnpublishFactKind;
  /** Rows the artist can lose something by is drawn in the warning tint. */
  isHard: boolean;
  /** The number the row quotes, when there is one. */
  figure: number | null;
}

/**
 * The consequences of taking this page offline, in the order they matter.
 *
 * Unpublishing makes the page a draft again — the state it had before its
 * first publish — so the honest list is the list of things a draft does not
 * have. The address is the one that costs: the server only reserves published
 * slugs, so while the page is down another page can take its address. Saying
 * "the address stays yours" would be a comfortable lie.
 *
 * A row appears only when it is true of this page.
 */
export function unpublishFactRows({
  pendingPresaveCount,
  viewCount,
}: {
  pendingPresaveCount: number | null;
  viewCount: number | null;
}): UnpublishFactRow[] {
  const rows: UnpublishFactRow[] = [
    { kind: UnpublishFactKind.offline, isHard: false, figure: null },
    { kind: UnpublishFactKind.address, isHard: true, figure: null },
  ];
  if (pendingPresaveCount !== null && pendingPresaveCount > 0) {
    rows.push({ kind: UnpublishFactKind.presaves, isHard: false, figure: pendingPresaveCount });
  }
  rows.push({ kind: UnpublishFactKind.analytics, isHard: false, figure: viewCount });
  return rows;
}
